/** Real-World Asset tickers — stocks/ETFs/commodities/indices/FX, торгуемые
 *  как perpetual contracts на DEX'ах (Paradex/Extended/Bitmart/Bybit). Используется
 *  для тумблера «Stocks Only» в Scanner и Funding screener — показать ТОЛЬКО
 *  RWA, скрыть крипто.
 *
 *  Список расширяемый: добавляй тикеры по мере встреч. Сравниваем по base
 *  (без `USDT` суффикса), т.к. на разных биржах префиксы разные.
 */
const _RWA = new Set<string>([
  // Extended 02.10 (см. stocks_known.py).
  'CDW', 'FANG', 'FTNT', 'GEHC', 'HON', 'NXPI', 'ODFL', 'STLD',
  // ---- Синхронизировано с backend_v2/stocks_known.py (2026-08-18):
  // бэкенд-список пополнялся (CXMT и ещё ~90), зеркало отставало —
  // тумблер «Stocks Only» такие акции не показывал.
  'AAL', 'AAOI', 'ABBV', 'ACHR', 'ACN', 'ADI', 'ADVANTEST', 'AEHR', 'AGG',
  'ALAB', 'ALB', 'AMKR', 'APD', 'APH', 'APLD', 'APP', 'ASTS', 'ASX',
  'AVAV', 'AXON', 'AXTI', 'BILI', 'BKNG', 'BLK', 'BNC', 'BOT', 'BRL',
  'BSP', 'CBRS', 'CCJ', 'CCL', 'CIEN', 'CMCSA', 'CMG', 'COHR', 'CPNG',
  'CVNA', 'CXMT', 'DKNG', 'EBAY', 'ENPH', 'EQIX', 'ETN', 'FCX', 'FLEX',
  'FLNC', 'FLQL', 'FOXA', 'FWDI', 'GEV', 'GFS', 'GIGADEV', 'GLW', 'GRAB',
  'HAL', 'HANMI', 'HIMS', 'HKD', 'HPE', 'HYUNDAI', 'IBB', 'IDR', 'IEMG',
  'IJH', 'INDA', 'INFQ', 'IONQ', 'IREN', 'ISRG', 'ITA', 'ITOT', 'IVV',
  'IWF', 'IWN', 'JBL', 'JMKE', 'KIOXIA', 'KLAC', 'KRW', 'LASERTEC', 'LIN',
  'LITE', 'LUNR', 'MAR', 'MCD', 'MEITUAN', 'MP', 'MUFG', 'MXL', 'MXN',
  'NAVER', 'NBIS', 'NEM', 'NOK', 'NTAP', 'NVO', 'OKLO', 'ONDS', 'OUST',
  'OXY', 'PAYP', 'PBR', 'PENG', 'PLUG', 'POET', 'POPMART', 'PPLT', 'QBTS',
  'RCAT', 'RDDT', 'RDW', 'RGTI', 'ROK', 'RUB', 'SAMSUNG', 'SAMSUNGEM', 'SAMSUNGUSD',
  'CYPH', 'GTLB', 'AGPU', 'OURA', 'YMTC', 'POLYMARKET', 'WBD', 'HPQ',
  'SBUX', 'SCCO', 'SGD', 'SGOV', 'SHAZ', 'SHEIN', 'SITM', 'VEEV', 'MNST', 'DJT', 'ABT', 'SKHY', 'SKHYNIX', 'SMR',
  'SNDK', 'SONY', 'SOXX', 'SPCX', 'SPGI', 'STRC', 'STX', 'SUMIELEC', 'TER',
  'THB', 'TIN', 'TMO', 'TMUS', 'TOKYOEL', 'TRY', 'TSEM', 'TTWO', 'UNG',
  'UNP', 'URA', 'USAR', 'USFR', 'VRT', 'VRTX', 'VST', 'VZ', 'WDC',
  'WEN', 'WM', 'XNG', 'ZAR', 'ZHONGJI',
  // ---- Stocks & ETFs (US) — mega/large cap + popular meme/AI ----
  'GPRO', // GoPro: hl io:GPRO + mexc GPROSTOCK (зеркало stocks_known.py)
  'NVDA', 'TSLA', 'AAPL', 'GME', 'AMC', 'MSTR', 'COIN', 'AMD', 'MSFT',
  'GOOGL', 'GOOG', 'AMZN', 'META', 'NFLX', 'BABA', 'SPOT', 'ASML',
  'NVDS', 'HOOD', 'RIVN', 'LCID', 'PLTR', 'BBAI', 'SOFI', 'RBLX',
  'NET', 'SNOW', 'DDOG', 'CRM', 'NOW', 'ORCL', 'INTC', 'CSCO',
  'CRWD', 'DELL', 'F', 'GM', 'BA', 'KO', 'PEP', 'DIS', 'NKE',
  'WMT', 'TGT', 'COST', 'HD', 'LOW', 'JPM', 'V', 'MA',
  'BRKB', 'BRK', 'BAC', 'GS', 'MS', 'WFC', 'C',
  'XOM', 'CVX', 'SHEL', 'BP', 'PLNT', 'UNH', 'PFE', 'MRK', 'LLY', 'JNJ',
  // Tech / AI / cloud / semis
  'SMCI', 'AVGO', 'TSM', 'MU', 'QCOM', 'MRVL', 'PANW', 'ZS',
  'NU', 'LRCX', 'ADBE', 'INTU', 'PYPL', 'SQ', 'UBER', 'ABNB',
  'IBM', 'TXN', 'AMAT', 'ANET', 'WDAY', 'TEAM', 'ZM', 'DOCN', 'TWLO',
  'OKTA', 'TTD', 'SHOP', 'MDB', 'CFLX', 'CONFLUENT', 'PATH', 'AI',
  'ARM', 'CRDO', 'SOUN', 'SOUNDHOUND',
  'OPENAI', 'ANTHROPIC', 'SPACEX', 'STRIPE', 'SOFTBANK',
  // Space / aerospace / defense
  'RKLB', 'LMT', 'RTX', 'NOC', 'GD', 'LHX',  // RKLB = Rocket Lab
  'ASTR', 'PL', 'SPCE',  // Astra, Planet Labs, Virgin Galactic
  // EVs / batteries
  'NIO', 'LI', 'XPEV', 'BYD', 'BYDDY',
  // Pharma / biotech
  'MRNA', 'BNTX', 'NVAX', 'BIIB', 'GILD', 'AMGN', 'REGN',
  // Crypto-adjacent
  'CRCL', 'CRWV', 'BMNR', 'RIOT', 'MARA', 'CLSK', 'HUT',
  // Finance / brokers
  'SCHW', 'COF', 'AXP',
  // China / int'l
  'PDD', 'JD', 'NTES', 'BIDU', 'TCEHY', 'TCOM', 'TME',
  'ICBC', 'BAVA',
  // ETFs / Indices
  'SPY', 'QQQ', 'IWM', 'ARKK', 'TLT', 'GLD', 'SLV', 'TQQQ', 'TQQQX',
  'SPX', 'DJI', 'NDX', 'NDQ', 'SP500', 'SP100',
  'DAX', 'FTSE', 'NIKKEI', 'US100', 'US500', 'US30', 'USA500',
  'XYZ100', 'MAG7', 'SEMIS', 'BIOTECH', 'DEFENSE', 'ENERGY',
  'VOO', 'VTI', 'VEA', 'EWY', 'EWJ', 'EWZ', 'EWT', 'EFA', 'EEM',
  'SMALL2000', 'USBOND',
  // ---- Commodities ----
  'XAU', 'XAG', 'PAXG', 'GOLD', 'SILVER', 'GOLDJM', 'GLDMINE',
  'OIL', 'WTI', 'BRENT', 'CL', 'BRENTOIL',
  'USOIL', 'UKOIL', 'BZ', 'XTI', 'XBR',
  'NG', 'GAS', 'NATGAS', 'NATURALGAS',
  'COPPER', 'PALLADIUM', 'PLATINUM', 'ALUMINIUM', 'ALUMINUM',
  'WHEAT', 'CORN', 'COTTON', 'COFFEE', 'COCOA', 'SUGAR', 'SOY',
  'URANIUM', 'LITHIUM', 'NICKEL', 'ZINC',
  // ---- Forex / Macro ----
  'EUR', 'GBP', 'JPY', 'CHF', 'AUD', 'CAD', 'NZD', 'CNY', 'INR',
  'EURUSD', 'GBPUSD', 'USDJPY', 'USDCHF', 'DXY',
  // ---- Other RWA / Real Estate / Bonds ----
  'TBILL', 'BIL', 'BOND', 'USBONDS',
  'CEG',  // Constellation Energy
  'POD',  // Podium
  // Аудит спот-обёрток 2026-08-18 (зеркало backend stocks_known.py)
  'BE', 'CELH', 'KHC', 'SBET', 'DVN', 'IBKR', 'KKR', 'WPM', 'SNPS', 'NTRA',
  'CDNS', 'VLO', 'BKR', 'DHR', 'IQV', 'ROL', 'TEM', 'FAST', 'SAP', 'KEYS',
  'PWR', 'COPX',
]);
export const RWA_TICKERS: ReadonlySet<string> = _RWA;

/** Свежие листинги: бэкенд опознаёт акции по цене (auto_mapping) раньше, чем
 *  их впишут в этот список руками. Дописываем их один раз за сессию. */
let _learnedLoaded = false;
export function loadLearnedStocks(get: (url: string) => Promise<{ data: unknown }>): void {
  if (_learnedLoaded) return;
  _learnedLoaded = true;
  get('/api/learned-stocks')
    .then(r => { if (Array.isArray(r.data)) for (const t of r.data) if (typeof t === 'string') _RWA.add(t.toUpperCase()); })
    .catch(() => { _learnedLoaded = false; });
}


/** Возвращает true если symbol — RWA (по base без USDT). */
export function isRwa(symbol: string): boolean {
  if (!symbol) return false;
  const up = symbol.toUpperCase();
  // Strip USDT-like suffix.
  let base = up;
  for (const suf of ['USDT', 'USD', 'USDC', '-PERP', 'PERP']) {
    if (base.endsWith(suf)) { base = base.slice(0, -suf.length); break; }
  }
  // Strip multiplier prefix (1000, 10000, 1M etc).
  for (const pre of ['1000000', '100000', '10000', '1000', '1M', '100']) {
    if (base.startsWith(pre) && base.length > pre.length && /[A-Z]/.test(base[pre.length])) {
      base = base.slice(pre.length);
      break;
    }
  }
  return RWA_TICKERS.has(base);
}
